import { PayloadAction } from '@reduxjs/toolkit';
import {
  LineItem,
  QuantityBreak,
} from '@snap-types/models/auto-configurator/state';

import { WritableAutoConfiguratorState } from '../slice';
import { revalidateLineQuantities } from '../validation/revalidate-line-quantities';

type Payload = { quoteLine: LineItem; quotePrices: QuantityBreak[] };

export function addDuplicatedLine(
  state: WritableAutoConfiguratorState,
  { payload: { quoteLine, quotePrices } }: PayloadAction<Payload>,
) {
  quoteLine.quantityBreakUuids = quotePrices.map((qb) => qb.uuid);

  state.lineItemUuids.push(quoteLine.uuid);
  state.lineItems[quoteLine.uuid] = quoteLine;

  for (const quantityBreak of quotePrices) {
    state.quantityBreaks[quantityBreak.uuid] = quantityBreak;
  }

  revalidateLineQuantities(state, quoteLine.uuid);
}
